export default __webpack_public_path__ + "static/media/cc_olive.c3ae02c2.jpg";